export const Paths = {
  login:                  "login",
  changePasswordRequired: "change-password-required",
  home:                   "home",
};